module.exports = __webpack_public_path__ + "img/quiz_04.9b7e226a.jpg";